import type { AdminService } from '../services/adminService'
import type { GroupMember } from '../types'
import { wireApiClient as client } from './wireApiClient'
import { workflowGroups } from '../../auth/workflowGroups'

// The response key holding group membership may be obfuscated in customer
// deployments. We normalise it onto the fixed `uiasgroups` field here so the
// rest of the app never needs to know the raw key name.
function normalise(raw: Record<string, unknown>): GroupMember {
  return {
    username: raw.username as string,
    name:     raw.name     as string,
    email:    raw.email    as string,
    dn:       raw.dn       as string,
    agency:   raw.agency   as string,
    uiasgroups: (raw[workflowGroups.responseKey] as string[]) ?? [],
    topics:  (raw.topics  as string[]) ?? [],
    regions: (raw.regions as string[]) ?? [],
  }
}

export const httpAdminService: AdminService = {
  async getGroupMembers(group: string) {
    const { data } = await client.get<Record<string, unknown>[]>(
      '/admin/clients-by-group',
      { params: { group } },
    )
    return data.map(normalise)
  },
}
